import { FIELDS } from "./fields";

export const TAX_TYPE_TABLE_COLUMNS = [
    { id: FIELDS.taxCode.key, label: FIELDS.taxCode.name },
    { id: FIELDS.name.key, label: FIELDS.name.name },
    { id: FIELDS.description.key, label: FIELDS.description.name },
    { id: FIELDS.applyRetention.key, label: FIELDS.applyRetention.name },
]